import { skip } from 'rxjs/operators';
import { Params } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';

// env
import { environment } from 'src/environments/environment';

// enums
import { Rent_Type } from 'src/app/core/enums/ads/rent-types';
import { Price_Type } from 'src/app/core/enums/ads/price-types';
import { ADVERTISEMENT_TYPE } from 'src/app/core/enums/ads/ads-types';
import { Category_Type } from 'src/app/core/enums/category/cat-type';
import { Contract_Type } from 'src/app/core/enums/ads/contract-types';
import { CRUD_COMPONENT } from 'src/app/core/enums/global/crud-types';
import { RANDOM_VALUE } from 'src/app/core/enums/global/random-value';
import { ADV_CLASS_TYPE } from 'src/app/core/enums/ads/advertiser-types';
import { FEATURES_TYPE } from 'src/app/core/enums/features/features-type';
import { AD_CONFIG_SERVICE_TYPE } from './enums/ad-configuration-service-type';
import { CATEGOR_VALUE_TYPE } from 'src/app/core/enums/category/cate-value-types';

// interfaces
import { ICity } from 'src/app/core/interfaces/location/city';
import { IArea } from 'src/app/core/interfaces/location/area';
import { agencyType } from 'src/app/core/enums/user/agency-type';
import { ICompany } from 'src/app/core/interfaces/ads/companies';
import { IUserInfo  } from 'src/app/core/interfaces/user/user-info';
import { ICategory } from 'src/app/core/interfaces/category/category';
import { IPaymentPlan } from 'src/app/core/interfaces/ads/payment-plan';
import { IAdvertisementResponse, IAdvertisementUnit } from 'src/app/core/interfaces/ads/advertisement';

// services
import { IRegion } from 'src/app/core/interfaces/location/region';
import { GlobleService } from 'src/app/core/services/globle.service';
import { AuthService } from 'src/app/core/services/user/auth.service';
import { AdOperationService } from 'src/app/core/services/ad/ad-operations/ad-operations.service';
import { ApiResponseService } from 'src/app/core/services/handel-api-response/api-response.service';

// validators
import AdsValidators from 'src/app/core/validations/ads/ads-validators';
import { ValidationsUrl } from 'src/app/core/validations/validation-url';
import { Validations_Comparison } from 'src/app/core/validations/ads/validation-comparison';
import OverrideValidators from 'src/app/core/validations/validators-override/validators-override';

// classes
import { CategoryHandler } from 'src/app/core/classes/category-handler';
import { LocationHandler } from 'src/app/core/classes/location-handler';

// reusable
import { listOfRentType } from 'src/app/core/reusable-objects/globle-objs/rent-list';
import { ListOfContractType } from 'src/app/core/reusable-objects/globle-objs/contract-list';

// tokens
export const AD_CONFIG_SERVICE_TYPE_TOKEN = new InjectionToken<AD_CONFIG_SERVICE_TYPE>('TO HANDLER BEHAVIOR SERVICE WITH EACH AD TYPE')

@Injectable()
export class AdConfigurationService {

  /**
   * fields
   */
  /**
   * 
   */
  private _form: FormGroup

  /**
   * 
   */
  public IsLoading: boolean = false;

  /**
   * @description that data return in update moe
   */
  public adData: {[key: string]: any} = null;

  /**
   * @description all data that user select it at from after handler with ui Keys
   */
  public PreviewCurrentFormData: IAdvertisementResponse = null

  /**
   * 
   */
  public RentType: Rent_Type = null;

  /**
   * 
   */
  private _subProperties: any[] = [];

  /**
   * 
   */
  private _mainProperties: any[] = [];

  /**
   * 
   */
  public IsLoadingProperties: boolean = false;

  /**
   * @description will has liveSearch result for type ad Building
   */
  public filteredUnits$: Subject<IAdvertisementUnit[]> = new Subject();

  /**
   * @description will has liveSearch result for type ad Building
   */
  public Units: any[] = null;

  /**
   * @description will has liveSearch result for type Planing
   */
  public Lands: any[] = null;

  /**
   * @description will has liveSearch result for type Villas
   */
  public Villas: any[] = null;

  /**
   * @description will has liveSearch result for type Villas
   */
  public Buildings: any[] = null;  

  /**
   * 
   */
  public Banks: any[] = null;

  /**
   * 
   */
  public SaleServices: any[] = null;  

  /**
   * 
   */
  public Companies: ICompany[] = null;    

  /**
   * 
   */
  public PaymentPlans: IPaymentPlan[] = null;

  /**
   * 
   */
  public ContractType: Contract_Type = null;

  /**
   * 
   */
  private _listOfContractType = ListOfContractType;

  /**
   * 
   */
  public IsOperationCreatedMode: boolean = true 

  /**
   * 
   */
  private _categoryType: CATEGOR_VALUE_TYPE = null

  /**
   * 
   */
  public _coords: google.maps.LatLngLiteral = null

  /**
   * 
   */
  private _categoryHandler: CategoryHandler = null;

  /**
   * 
   */
  private _locationHandler: LocationHandler = null;
  
  /**
   * 
   */
  private _priceType: Price_Type = Price_Type.normal;



  constructor(
    private readonly _fb: FormBuilder,
    private readonly _g: GlobleService,
    private readonly _auth: AuthService,
    private readonly _adService: AdOperationService,
    private readonly _api: ApiResponseService,
    @Inject(AD_CONFIG_SERVICE_TYPE_TOKEN) private readonly _type: AD_CONFIG_SERVICE_TYPE
  ) {}

  /**
   * Getters & Setters
   */

  /**
   * UserInfo
   */
  private get _userInfo(): IUserInfo  {
    return this._auth.userInfo.value
  }

  /**
   * 
   */
  private get _userDefinitions() {

    if ((this._userInfo?.parentAgencyType || this._userInfo?.agencyType) == agencyType.freeWork) return {
      idType: '1',
      idNumber: this._userInfo.idNumber
    }

    return {
      idType: '2',
      idNumber: this._userInfo.licenseNumber
    }

  }  

  /**
   * Form
   */
  public get Form(): FormGroup {
    return this._form
  }

  /**
   * Regions
   */
  public get Regions(): IRegion[] {
    return this._locationHandler.regions
  }

  /**
   * Regions
   */
  public set Regions(items: IRegion[]) {
    this._locationHandler.regions = items
  }  

  /**
   * Cities
   */
  public get Cities(): ICity[] {
    return this._locationHandler.cities
  }

  /**
   * IsLoadingCities
   */
  public get IsLoadingCities(): boolean {
    return this._locationHandler.isLoadingCities
  }  


  /**
   * Areas
   */
   public get Areas(): IArea[] {
    return this._locationHandler.areas
  }
  
  /**
   * IsLoadingAreas
   */
  public get IsLoadingAreas(): boolean {
    return this._locationHandler.isLoadingAreas

  } 

  /**
   * Categories
   */
  public get Categories(): ICategory[] {
    return this._categoryHandler.items
  }

  /**
   * Categories
   */
  public set Categories(items: ICategory[]) {
    this._categoryHandler.items = items
  }

  /**
   * CategoryType
   */
  public get CategoryType(): CATEGOR_VALUE_TYPE {
    return this._categoryType
  }
  
  /**
   * set CategoryType
   */
  private set CategoryType(type: CATEGOR_VALUE_TYPE) {
    this._categoryType = type
  }  
  
  /**
   * SubCatagories
   */
   public get SubCatagories(): ICategory[] {
    return this._categoryHandler.subItems
  }

  /**
   * MainPropertiesControl
   */
  public get MainPropertiesControl(): FormArray {
    return this.control('properties') as FormArray
  }

  /**
   * SubPropertiesControl
   */
  public get SubPropertiesControl(): FormArray {
    return this.control('features') as FormArray
  }

  /**
   * _mainProperties
   */
  public get MainProperties(): any[] {
    return this._mainProperties
  }

  /**
   * set _mainProperties
   */
  private set MainProperties(props: any[]) {
    this._mainProperties = props;
  }

  /**
   * _subProperties
   */
  public get SubProperties(): any[] {
    return this._subProperties
  }

  /**
   * set _subProperties
   */
  private set SubProperties(props: any[]) {
    this._subProperties = props;
  } 

  /**
   * Coords
   */
  public get Coords(): google.maps.LatLngLiteral {
    return this._coords
  }

  /**
   * 
   * @param coords google.maps.LatLngLiteral
   */
  public set Coords(coords: google.maps.LatLngLiteral) {

    // ES6 Destruction
    const { lat, lng } = coords;

    /**
     * check if location is disabled, because, location formState is disabled to make sure if user select area
     */
    if (this.control('location').disabled === true) this.control('location').enable();

    /**
     * change location because the location zone in map will change every time the area is change
     */
    this.control('location').patchValue([lng, lat]);

    /**
     * 
     */
    this._coords = coords;

  }  
  

  /**
   * @description some controls names label need change with each category type
   * so this getter method check type in field CategoryType to handler labels values
   */
  public get ControlLabelValueType() {

    /**
     * init
     */
    let labels: {
      sizeLabel: string
      priceLabel: string
      sketchLabel: string
      addressLabel: string
      unitNumberLabel: string
      totalPriceLabel?: string
    } = null;

    /**
     * handler labels with each CategoryType
     */
    switch(this.CategoryType) {
      default:
      case CATEGOR_VALUE_TYPE.BL:
        labels = {
          priceLabel: 'سعر العقار',
          sizeLabel: 'مساحة العقار',
          addressLabel: 'عنوان العقار',
          unitNumberLabel: 'رقم العماره',
          sketchLabel: 'ملف كيروكي العقار',
        }
        break;
      case CATEGOR_VALUE_TYPE.PL:
        labels = {
          priceLabel: 'سعر المتر',
          sizeLabel: 'مساحة المخطط',
          addressLabel: 'عنوان المخطط',
          unitNumberLabel: 'رقم المخطط',
          totalPriceLabel: 'سعر المخطط',
          sketchLabel: 'ملف كيروكي المخطط',
        }
        break;
      case CATEGOR_VALUE_TYPE.VL:
        labels = {
          priceLabel: 'سعر العقار',
          sizeLabel: 'مساحة العقار',
          unitNumberLabel: 'رقم العماره',
          addressLabel: 'عنوان المجمع',
          sketchLabel: 'ملف كيروكي العقار',
        }
        break;
      case CATEGOR_VALUE_TYPE.LN:
        labels = {
          priceLabel: 'سعر المتر',
          sizeLabel: 'مساحة الارض',
          totalPriceLabel: 'سعر الارض',
          addressLabel: 'عنوان الارض',
          unitNumberLabel: 'رقم الارض',
          sketchLabel: 'ملف كيروكي العقار',
        }
        break;                
    }

    /**
     * 
     */
    return labels

  } 

  /**
   * isBuilding
   */
  public get isBuilding(): boolean {

    /**
     * 
     */
    return this._adService.isBuilding(this.CategoryType);

  }

  /**
   * isPlaning
   */
  public get isPlaning(): boolean {

    /**
     * 
     */
    return this._adService.isPlaning(this.CategoryType);

  }

  /**
   * isVillas
   */
  public get isVillas(): boolean {

    /**
     * 
     */
    return this._adService.isVillas(this.CategoryType);

  }

  /**
   * isOffPlanSale
   */
  public get isOffPlanSale(): boolean {

    /**
     * 
     */
    return this._adService.isOffPlanSale(this.CategoryType);

  }  
  
  /**
   * isNormal
   */
  public get isNormal(): boolean {
    
    /**
     * 
     */
    return this._adService.isNormal(this.CategoryType);

  }

  /**
   * isLand
   */
  public get isLand(): boolean {
    
    /**
     * 
     */
    return this._adService.isLand(this.CategoryType)

  } 
  
  /**
   * @description check if current category type from types has Bundled Ads
   * @returns if BL or PL or VL return true else false
   */
  public get IsHasBundledAds(): boolean {
    return this._adService.IsHasBundledAds(this.CategoryType)
  }  

  /**
   * ListOfContractType
   */
  public get ListOfContractType(): typeof ListOfContractType {
    return this._listOfContractType
  }

  /**
   * ListOfContractType
   */
  public set ListOfContractType(list: typeof ListOfContractType) {
    this._listOfContractType = list;
  }  

  /**
   * listOfRentType
   */
  public get listOfRentType(): typeof listOfRentType {
    return listOfRentType
  }  

  /**
   * showRent
   */
  public get showRent(): boolean {
    return this.ContractType === Contract_Type.RT
  }

  /**
   * rentalPriceTitle
   */
  public get rentalPriceTitle(): string {

    switch(this.RentType) {
      case Rent_Type.DY:
        return 'سعر الايجار ( اليومي )';
      case Rent_Type.MY:
        return 'سعر الايجار ( الشهري )';
      case Rent_Type.YY:
        return 'سعر الايجار ( السنوي )';
      case Rent_Type.OP:
        return 'سعر الايجار ( حسب الفترة المحددة )';
      default:
        return 'سعر الايجار'
    }

  }

  /**
   * Price_Type
   */
  public get PriceType(): Price_Type {
    return this._priceType;
  }

  /**
   * set Price_Type
   */
  private set PriceType(type: Price_Type) {
    this._priceType = type;
  }  

  /**
   * salePriceTitle
   */
  public get salePriceTitle(): string {

    switch(this.PriceType) {
      case Price_Type.soom:
        return 'بداية السوم';
      case Price_Type.startsFrom:
        if (this.CategoryType == CATEGOR_VALUE_TYPE.PL) {
          return 'تبدأ الأسعار من ( المتر )'
        }
        return 'تبدأ الأسعار من';
      default:
        return  this.ControlLabelValueType.priceLabel
    }

  }

  /**
   * @description check if priceType is ON_SOOM
   */
  public get IsOnSoomPrice(): boolean {
    return this.PriceType === Price_Type.soom
  }

  /**
   * @description check if priceType is NORMAL
   */
  public get IsNormalPrice(): boolean {
    return this.PriceType === Price_Type.normal
  }

  /**
   * @description check if priceType is NORMAL
   */
  public get IStartFromPrice(): boolean {
    return this.PriceType === Price_Type.startsFrom
  }
  

  /**
   * Methods
   */

  /**
   * 
   */
  public Init(OperationMode: CRUD_COMPONENT): void {

    /**
     * init
     */ 
    this.IsOperationCreatedMode =  OperationMode === CRUD_COMPONENT.create;

    /**
     * init FormBuilder
     */
    this._initForm();
 
    /**
     * init LocationHandler
     */
    this._locationHandler = new LocationHandler([], this._api);  

    /**
     * watch changes to reset controls Values for locationHandler
     */
    this._locationHandler
        .watchChange
        .pipe(
          skip(this.IsOperationCreatedMode ? null : 3)
        )        
        .subscribe(index => {
          this._locationHandler
              .sortedControls
              .slice(index)
              .forEach(controlName => this.control(controlName).setValue(null))
        })     
      
    /**
     * init CategoryHandler
    */     
    this._categoryHandler = new CategoryHandler([]); 

    /**
     * watch changes to reset controls Values for categoryHandler
     */
    this._categoryHandler
        .watchChange
        .pipe(
          skip(this.IsOperationCreatedMode ? 0 : 1)
        )
        .subscribe(_ => {
          this.Form.get('subCategory').setValue(null);
        })

    /**
     * handler service by type
     */
    switch(this._type) {
      case AD_CONFIG_SERVICE_TYPE.advertisement:
        this._advertisementType();
        break;
      case AD_CONFIG_SERVICE_TYPE.request:
        this._adRequestType();
        break;
      case AD_CONFIG_SERVICE_TYPE.search:
        break;
      default:
        break;
    }

    /**
     * For Test
     */
    if (environment.production == false) {
      this.Form.valueChanges.subscribe(r => {
        console.log(this.Form)
        console.log('Ad Service Type Is:', this._type)
      })
    }    

  }

  /**
   * 
   */
  private _initForm(): void {

    /**
     * init default form For All Ad Types
     */
    this._form = this._fb.group({
      enableInstallment: [false],
      enablePhoneContact: [false],
      features: this._fb.array([]),
      properties: this._fb.array([]),
      priceType: [Price_Type.normal],
      city: [null, Validators.required],
      area: [null, Validators.required],
      category: [null, Validators.required],
      subCategory: [null, Validators.required],
      type: [ADVERTISEMENT_TYPE.Ready, Validators.required],
      contractType: [Contract_Type.SE, Validators.required],
    })

  }

  /**
   * 
   * @param controlName name of control
   * @returns AbstractControl | null
   */
  public control(controlName: string): AbstractControl {
    return this.Form.controls[controlName]
  }

  /**
   * HandlerGetCitiesByRegion
   */
  public async HandlerGetCitiesByRegion(region: IRegion) {

    // ES6 Destruction
    const { id } = region;

    /**
     * get cities by api request
     */
    return this._locationHandler.findCitesByRegionId(id)

  }

  /**
   * HandlerGetAreasByCity
   */
  public async HandlerGetAreasByCity(city: ICity) {
    
    // ES6 Destruction
    const { id } = city;

    /**
     * get areas by api request
     */
    return this._locationHandler.findAreaByCityId(id);

  }

  /**
   * HandlerGetArea
   */
  public HandlerGetArea(area: IArea): void {

    // ES6 Destruction & Nested
    const { location: { coordinates: [ lng, lat ] } } = area;

    /**
     * 
     */
    this.Coords = { lat, lng };

  }

  /**
   * HandlerSubCategory
   */
  public HandlerGetSubCategoryByMain(category: ICategory): void {

    /**
     * 
     */
    this.CategoryType = category.type;

    /**
     * 
     */
    this._categoryHandler.findSubCategories(category);

  }  

  /**
   * HandlerPropertiesBySubCategory
   */
  public async HandlerPropertiesBySubCategory(subCategory: ICategory) {

    // ES6 Destruction
    const { id } = subCategory || {};
    
    /**
     * init http params
     */
    const params = { category: id, [RANDOM_VALUE.loader]: true };

    /**
     * reset controls
     */
    this.SubPropertiesControl.clear();
    this.MainPropertiesControl.clear();

    /**
     * 
     */
    return this._handlerGetPropertiesBySubCategory(params);
        
  }

  /**
   * HandlerGetAdProperties
   */
  private async _handlerGetPropertiesBySubCategory(params: Params) {
    
    /**
     * 
     */
    this.IsLoadingProperties = true;

    /**
     * disabled to prevent user to select any other item until end load features
     */
    this.control('subCategory').disable();

    /**
     * 
     */
    const sub = this._api.AdFeatures({ params: { ...params, type: Category_Type.sub } });
    const main = this._api.AdFeatures({ params: { ...params, type: Category_Type.main } });   
    
    /**
     * 
     */
    const p = new Promise((resolve, reject) => {
      
      /**
       * 
       */
      combineLatest([main, sub])
      .subscribe(
        (res: any) => {
    
          // ES6 Destructing
          const [ main, sub ] = res;
  
          // set value
          this.SubProperties = sub
          this.MainProperties = main;
  
          /**
           * sort array
           */
          this
            .MainProperties
            .sort((a, b) => {
              if (a.type === FEATURES_TYPE.list) return -1;
              if (a.type === FEATURES_TYPE.number) return 1;
              return 0;
            })
  
          /**
           * update main Props
           */
          this.MainProperties.forEach((prop) => {
  
            // ES6 Detraction
            const { id: init, required } = prop;
  
            /**
             * 
             */
            this._pushPropertiesControls(Category_Type.main, { 
              init,
              required,
            })
  
          })
          
          /**
           * update sub Props
           */  
          this.SubProperties.forEach((prop) => {
            
  
            // ES6 Detraction
            const { required } = prop;
  
            /**
             * 
             */
            this._pushPropertiesControls(Category_Type.sub, {
              required,
              single: true
            })
            
          })
          
          /**
           * 
           */
          this.IsLoadingProperties = false;
  
          /**
           * 
           */
          this.control('subCategory').enable();

          /**
           * 
           */
          resolve(null);
          
        },
        err => {
  
          /**
           * 
           */
          this.IsLoadingProperties = false;
  
          /**
           * 
           */
          this.control('subCategory').enable();      
          
          /**
           * 
           */
          reject(err);
  
        }
      )

    });

    /**
     * 
     */
    return p;
    
  }

  /**
   * 
   * @param type MAIN - SUB
   * @param config { single: boolean, init: any, required: boolean }
   * @description to update controls, Properties & Features for push new controls in it's
   * if ( single ) push FormControl, else push FromGroup, ( init ) is control intiValue, ( required ) control required.
   * if type is MAIN then push in MainPropertiesControl,
   * if type is SUB then push in SubPropertiesControl,
   */
  private _pushPropertiesControls(type: Category_Type, config?: { single?: boolean, init?: any, required?: boolean, propValue?: string | number }) {

    // ES6 Destructuring
    const { single, init, required, propValue } = config || {};
  
    /**
     * init
     */
    let propsControl = null;
    /**
     * 
     */
    switch(type) {
      case Category_Type.main:
        propsControl = this.MainPropertiesControl;
        break;
      case Category_Type.sub:
        propsControl = this.SubPropertiesControl;        
        break;
      default:
        break;
    }

    if (single === true) propsControl.push(this._fb.control(init, required ? Validators.required : null))
    else {
      propsControl.push(
        this._fb.group({
          property: [init],
          value: [propValue, required ? Validators.required : null]
        })
      )  
    }

    /**
     * update propsControl
     */
    propsControl.updateValueAndValidity();

  } 
  
  /**
   * 
   * @param type 
   */
  public PriceTypeToggle(type: Price_Type | null): void {

    /**
     * 
     */
    if (type !== null) this.PriceType = type;
    else this.PriceType = Price_Type.normal;

  }  

  /**
   * 
   */
  private _advertisementType(): void {

    /**
     * locations
    */
   this.Form.addControl('title_ar', this._fb.control(null));
    this.Form.addControl('title_en', this._fb.control(null));
    this.Form.addControl('address_en', this._fb.control(null));
    this.Form.addControl('streetName', this._fb.control(null));
    this.Form.addControl('region', this._fb.control(null, Validators.required));
    this.Form.addControl('location', this._fb.control({value: null, disabled: true}));
    this.Form.addControl('address_ar', this._fb.control(null, OverrideValidators.required));
    this.Form.addControl('unitNumber', this._fb.control(null, OverrideValidators.pattern('^[A-z0-9\u0621-\u064A\u0660-\u06690-9\?:,[\]\-_+\|]*$', 'الصيغة غير صحيحة')));

    /**
     * files
    */
    this.Form.addControl('sketch', this._fb.control(null));
    this.Form.addControl('adsFile', this._fb.control(null));
    this.Form.addControl('contract', this._fb.control(null));
    this.Form.addControl('link3D', this._fb.control(null, ValidationsUrl));
    this.Form.addControl('qrCodeUrl', this._fb.control(null, ValidationsUrl));
    this.Form.addControl('imgs', this._fb.control(null, OverrideValidators.required));

    /**
     * owner info
     */
    this.Form.addControl('adNumber', this._fb.control(null));
    this.Form.addControl('licenseEndDate', this._fb.control(null));
    this.Form.addControl('advertiserName', this._fb.control(null));
    this.Form.addControl('commissionNumber', this._fb.control(null));
    this.Form.addControl('idType', this._fb.control(this._userInfo.idType, Validators.required));
    this.Form.addControl('advertiserClass', this._fb.control(ADV_CLASS_TYPE.commissar, Validators.required));
    this.Form.addControl('idNumber', this._fb.control(this._userDefinitions.idNumber, Validators.required));

    /**
     * Writing fields
     */
    // this.Form.addControl('guarantees', this._fb.control(false));
    // this.Form.addControl('saudiBuildingCode', this._fb.control(false));
    // this.Form.addControl('contraindications', this._fb.control(false));
    // this.Form.addControl('undocumentedRights', this._fb.control(false));
    // this.Form.addControl('influentialInformation', this._fb.control(false));
    // this.Form.addControl('guaranteesDesc', this._fb.control({value: null, disabled: true}, OverrideValidators.required));
    // this.Form.addControl('contraindicationsDesc', this._fb.control({value: null, disabled: true}, OverrideValidators.required));
    // this.Form.addControl('undocumentedRightsDesc', this._fb.control({value: null, disabled: true}, OverrideValidators.required));
    // this.Form.addControl('influentialInformationDesc', this._fb.control({value: null, disabled: true}, OverrideValidators.required));
    this.Form.addControl('description_en', this._fb.control(null, Validators.required));
    this.Form.addControl('bestFeature_en', this._fb.control(null, Validators.required));
    this.Form.addControl('description_ar', this._fb.control(null, OverrideValidators.required));
    this.Form.addControl('bestFeature_ar', this._fb.control(null, OverrideValidators.required));

    /**
     * Others fields
     */
    this.Form.addControl('deposit', this._fb.control({ value: null, disabled: true }, [
      OverrideValidators.required,
      OverrideValidators.minlength(1)
    ]));
    this.Form.addControl('banks', this._fb.control(null));
    this.Form.addControl('services', this._fb.control(null));
    this.Form.addControl('hasDeposit', this._fb.control(false));
    this.Form.addControl('paymentPlan', this._fb.control(null));
    this.Form.addControl('company', this._fb.control(null, OverrideValidators.required));
    this.Form.addControl('size', this._fb.control(null, [OverrideValidators.required, OverrideValidators.minlength(1)]));
    this.Form.addControl('price', this._fb.control(null, [OverrideValidators.required, OverrideValidators.minlength(1)]));

    /**
     * update Validation
     */
    this.Form.addValidators(AdsValidators.maxDeposit(this.CategoryType));

    /**
     * 
     */
    this.Form.updateValueAndValidity();    

  }

  /**
   * 
   */
  private _adRequestType(): void {

    /**
     * owner info
     */
    this.Form.addControl('owner', this._fb.control(this._g.CorrectUserId));
    this.Form.addControl('advertiserName', this._fb.control(null));
    this.Form.addControl('commissionNumber', this._fb.control(null));
    this.Form.addControl('idType', this._fb.control(this._userInfo.idType, Validators.required));
    this.Form.addControl('idNumber', this._fb.control(this._userDefinitions.idNumber, Validators.required));
    this.Form.addControl('advertiserClass', this._fb.control(ADV_CLASS_TYPE.commissar, Validators.required));

    /**
     * Writing fields
     */
    this.Form.addControl('description_en', this._fb.control(null, Validators.required));
    this.Form.addControl('description_ar', this._fb.control(null, OverrideValidators.required));

    /**
     * Others fields
     */
    this.Form.addControl('priceTo', this._fb.control(null));
    this.Form.addControl('priceFrom', this._fb.control(null));
    this.Form.addControl('sizeTo', this._fb.control(null, Validators.required));
    this.Form.addControl('sizeFrom', this._fb.control(null, Validators.required));

    /**
     * update Validation
     */
    this.Form.addValidators([
      Validations_Comparison(['sizeFrom', 'sizeTo', 'size'], true),
      Validations_Comparison(['priceFrom', 'priceTo', 'price'], false), 
    ])

    /**
     * 
     */
    this.Form.updateValueAndValidity();

  }

  /**
   * 
   */
  public HandlerPreviewCurrentFormData(): void {

    /**
     * init
     */
    const preview = {...this.Form.value};

    /**
     * 
     */
    for (const key in preview) {

      /**
       * skip this key
       */
      if (preview[key] == null) continue;

      /**
       * 
       */
      switch(key) {
        case 'area':
          
          /**
           * get full Object value
           */
          const area = this.Areas.find(area => area.id === preview[key]);
          const city = this.Cities.find(city => city.id === area.city);
          const region = this.Regions.find(region => region.id === city.region);

          /**
           * fill it
           */
          preview['area'] = area;
          preview['city'] = city;
          preview['region'] = region;

          break;
        case 'subCategory':
          
          /**
           * 
           */
          const subCategory = this.SubCatagories.find(category => category.id === preview[key]);
          const category = this.Categories.find(category => category.id === subCategory.parent);

          /**
           * fill it
           */
          preview['category'] = category;
          preview['subCategory'] = subCategory;

          break;
        case 'units':

          /**
           * init
           */
          const units = preview[key] as Array<{ unit: number[], floor: number }>;

          /**
           * 
           */
          const unitsMapping = units.map(floor => {
            
            // ES6 Destruction
            const { unit } = floor;

            /**
             * Mapping
             */
            const unitMapping = unit?.map(u => ({ ...this.Units.find(e => e.id === u) }))
            

            return { ...floor, unit: unitMapping }

          })

          /**
           * fill it
           */
          preview[key] = unitsMapping;

          break;
        case 'zones':

          const zones = preview[key] as any[];

          preview[key] = zones.map(zone => ({...zone, lands: this.Lands.filter(land => zone.lands.includes(land?.id))}))

          break;
        // case 'lands':
        case 'villas':
        case 'buildings':
        case 'banks':
        case 'services':

          let arr: any[] = null;

          switch(key) {
            // case 'lands':
            //   arr = this.Lands;
            //   break
            case 'villas':
              arr = this.Villas;
              break
            case 'buildings':
              arr = this.Buildings;
              break              
            case 'banks':
              arr = this.Banks;
              break
            case 'services':
              arr = this.SaleServices;
              break                                          
          }

          /**
           * fill it
           */
          if (Array.isArray(arr) && arr.length > 0) {
            preview[key] = arr.filter(item =>  preview[key].includes(item?.id)); 
          }
          break;
        case 'properties':

          /**
           * init
           */
          const props = preview[key] as any[];

          /**
           * 
           */
          const Mapping = props
                    .filter(prop => prop.value)
                    .map(prop => {

                      const obj = this.MainProperties.find(p => p.id === prop.property);

                      const value = obj.type === FEATURES_TYPE.list ? obj.options.find(opt => opt.id === prop.value) : prop.value;

                      return { ...obj, value: value }

                    }); 
          
          /**
           * fill it
           */
          preview[key] = Mapping
          break
        case 'features':
          /**
           * fill it
           */
          preview[key] = this.SubProperties.filter(prop => preview[key].includes(prop.id));           
          break
      }

    }

    /**
     * 
     */
    this.PreviewCurrentFormData = preview;

  }

  /**
   * 
   */
  public OnDestroy(): void {

    /**
     * 
     */
    this._categoryHandler.onDestroy();
    this._locationHandler.onDestroy();
     
  }  

}